module.exports = __webpack_public_path__ + "img/photos/placeholders/mechanics-01@2x.jpg";